export const Config = {
    service: null,
    env: null,
    urls: null,
    storageKeyJWT: "jwt",
    storageKeyReferrer: "referrer",
    storageKeyBooking: "mein-phoenix--buchung",
    storageKeySurname: "mein-phoenix--nachname",
    storageKeyBookingNr: "mein-phoenix--rechnr",
    storageKeyAgencyNr: "mein-phoenix--agenturnummer",
    storageKeyUserAbbr: "mein-phoenix--benutzer-kennung",
    storageKeyPermission: "mein-phoenix--permissions",
    storageKeyLastLogins: "mein-phoenix--last-logins",
    storageKeyRenewedAt: "mein-phoenix--jwt-renewed-at",
    html: {
        allowed: [
            "a",
            "i",
            "b",
            "small",
            "smaller",
            "strong",
            "em",
            "div",
            "p",
            "article",
            "section",
            "ul",
            "ol",
            "li",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr",
            "br",
            "span",
        ],
    },
    date: {
        patterns: {
            time: "HH:mm",
            de: "DD.MM.YYYY",
            en: "YYYY-MM-DD",
        },
        i18n: {
            de: {
                firstDay: 1,
                previousMonth: "Vorheriger Month",
                nextMonth: "Nächster Monat",
                months: [
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember",
                ],
                weekdays: [
                    "Sonntag",
                    "Montag",
                    "Dienstag",
                    "Mittwoch",
                    "Donnerstag",
                    "Freitag",
                    "Samstag",
                ],
                weekdaysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            },
        },
    },
    phoenix: {
        tel: "+49228 9260-0",
    },
    sentryIgnores: [
        "null",
        "timeout",
        '{"code":0}',
        "Berechtigung",
        "rpc.buchung-repo.extern-get-buchung",
        "ERR__DATEI_ZU_GROSS_MB",
        "unbekannte agentur-nr",
        "Unbekannte BN",
        "mit sich selbst",
        "bereits miteinander",
        "zeitlich nicht überschneiden",
        "zeitlich mit einem anderen Termin",
        "canceled",
        "excluded",
        "not-found",
        "unauthorized",
        "ERR__UNVERIFIED_JWT",
        "ERR__INVALID_PHONENUMBER",
        "ERR__EXCEPTION_IN_SERVICEFN",
        "ERR__TWO_FACTOR_AUTH_NO_CODE",
        "ERR__FEHLENDE_BUCHUNGS_BERECHTIGUNG",
        "gtag",
        "b.container[a]",
        "reading '360410'",
        "Illegal invocation",
        "QuotaExceededError",
        "_soundPlayingChanged",
        "Unexpected end of input",
        "Unexpected token 'else'",
        "MethodName:soundPlayingChanged",
        "getRestrictions is not a function",
        "MethodName:browserNotificationOpenUi",
        'redefine non-configurable property "userAgent"',
        "Identifier 'change_ua' has already been declared",
        "Object doesn't support property or method 'includes'",
        "SyntaxError: No identifiers allowed directly after numeric literal",
    ],
};
export const TRIPTYPE_SEE = "see";
export const TRIPTYPE_RIVER = "fluss";
export const TRIPTYPE_ORIENT = "orient";
export const PERM_WEBTEXTING = "textresourcenpflegen";
export default Config;
